import { signOut } from "@backend/AccountRequests";
import { EXTERNAL_AUTH_URL } from "@constants/ApiUrl";
import { Authentication, NoAuthenticated } from "@constants/TokenKeys";

function EntryPageViewModel() {
    async function logOut() {
        localStorage.setItem(Authentication, NoAuthenticated);
        await signOut();

    }

    async function redirectExternal() {
        const url = EXTERNAL_AUTH_URL;
        window.location.href = url;
    }

    return {
        logOut,
        redirectExternal,
    };
}

export default EntryPageViewModel;